import type { PageResult } from '@jiaofa/api-types'
import { request } from './request'

export interface MessageLog {
  id: string
  scene?: string
  receiver?: string
  channel?: string
  status?: string
  sentAt?: string
}

export interface MessageTemplate {
  id: string
  code: string
  scene?: string
  title?: string
  content?: string
  status?: string
  updatedAt?: string
}

export interface MessageTemplateSavePayload {
  id?: string
  code: string
  scene?: string
  wechatTemplateId?: string
  title?: string
  content: string
  enabled?: boolean
}

export interface MessageConfig {
  id: string
  scene: string
  enabled?: boolean
  channel?: string
}

export interface MessageConfigSavePayload {
  id?: string
  scene: string
  enabled?: boolean
  channel?: string
}

export const messageApiReady = true as const

export const fetchMessageLogs = async (params: { page?: number; pageSize?: number }): Promise<PageResult<MessageLog>> =>
  request<PageResult<MessageLog>>({
    url: '/messages',
    method: 'GET',
    params,
  })

export const fetchMessageTemplates = async (): Promise<MessageTemplate[]> =>
  request<MessageTemplate[]>({
    url: '/message-templates',
    method: 'GET',
  })

export const createMessageTemplate = async (payload: MessageTemplateSavePayload): Promise<void> =>
  request<void, MessageTemplateSavePayload>({
    url: '/message-templates',
    method: 'POST',
    data: payload,
  })

export const updateMessageTemplate = async (payload: MessageTemplateSavePayload): Promise<void> =>
  request<void, MessageTemplateSavePayload>({
    url: '/message-templates',
    method: 'PUT',
    data: payload,
  })

export const fetchMessageConfig = async (): Promise<MessageConfig[]> =>
  request<MessageConfig[]>({
    url: '/message-config',
    method: 'GET',
  })

export const updateMessageConfig = async (payload: MessageConfigSavePayload): Promise<void> =>
  request<void, MessageConfigSavePayload>({
    url: '/message-config',
    method: 'PUT',
    data: payload,
  })
